import { InserirUsuarioInput } from "../usuario.model";

export class GerenciaArquivo {
    id: number;
    nomeArquivo: string;
    usuario: string;
    dataUpload: Date;
    clienteId: number;
    diretorio: string;
}

export class GerenciaArquivoUsuario {
    id: number;
    gerenciaArquivoId: number;
    usuario: string;
    dataCadastro: Date;
    usuarioCadastro: string;

    usuarioOutPut: InserirUsuarioInput;
}


